<template>
  <section id="application-form-common-fields">
    <input
      :fieldValue="companyName"
      type="hidden"
      fieldTitle="機構名稱"
      :fieldname="asCompany ? 'company' :'vendor'"
    />
    <input
      :fieldValue="from"
      type="hidden"
      fieldTitle="Platform"
      fieldname="platform"
      fieldType="text"
    />
    <input
      :fieldValue="companyId"
      type="hidden"
      fieldTitle="機構ID"
      :fieldname="asCompany ? 'companyId' :'vendorId'"
      fieldType="companyId"
    />
    <input
      :fieldValue="vendorEmail"
      type="hidden"
      fieldTitle="vendorEmail"
      fieldname="vendorEmail"
      fieldType="vendorEmail"
    />
    <input
      :fieldValue="vendorMobile"
      type="hidden"
      fieldTitle="vendorMobile"
      fieldname="vendorMobile"
      fieldType="vendorMobile"
    />
    <!-- <input
      :fieldValue="terms"
      type="hidden"
      fieldTitle="terms"
      fieldname="terms"
      fieldType="terms"
    /> -->
    <input
      fieldValue="1"
      type="hidden"
      fieldTitle="isApplicationForm"
      fieldname="isApplicationForm"
      fieldType="isApplicationForm"
    />
    <input
      :fieldValue="productId"
      type="hidden"
      fieldTitle="productId"
      fieldname="productId"
      fieldType="productId"
    />
    <input
      :fieldValue="productType"
      type="hidden"
      fieldTitle="productType"
      fieldname="productType"
      fieldType="productType"
    />
  </section>
</template>
<script>
export default {
  name: "CommonFields",
  components: {},
  props: {
    companyName: {
      type: String,
      default: "",
    },
    companyId: {
      type: Number,
      default: 0,
    },
    from: {
      type: String,
      default: "web",
    },
    vendorEmail: {
      type: String,
      default: "",
    },
    vendorMobile: {
      type: String,
      default: "",
    },
    productId: {
      type: Number,
      default: 0,
    },
    productType: {
      type: String,
      default: "loan",
    },
    asCompany: {
      tyep: Boolean,
      default: false
    }
  },
  data: function () {
    return {};
  },
  computed: {
    terms() {
      let data = this.t("application.terms", { companyName: this.companyName });
      if (this.checkTu) {
        data += this.t("application.tu_terms", {
          companyName: this.companyName,
        });
      }
      return data;
    },
  },
  mounted() {},
  methods: {},
};
</script>
